import React, { useEffect, useRef } from "react";
import {
    CButton,
    CButtonGroup,
    CCard,
    CCardBody,
    CCardTitle,
    CCol,
    CContainer,
    CRow,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
} from "@coreui/react";
import Table from "../../components/Table";
import Helper from "../../application/helper";
import { useSelector } from "react-redux";
import Common from "./common";
import store from "../../storeWire";
import { setData } from "../../store/slice/customerAccount";
import { usePage } from "@inertiajs/inertia-react";
import CurrentBalance from "./CurrentBalance";
import CustomerSearch from "../../components/SearchInputs/CustomerSearch";
import DateDisplay from "../../components/DisplayData/DateDisplay";
import PrintAccountStatmentLink from "../../components/PrintAccountStatmentLink";

const List = () => {
    const p = usePage();
    const tableRef = useRef();
    const list = useSelector((state) => state.entities.component_table);
    const auth = useSelector((state) => state.entities.auth);
    useEffect(() => {
        store.dispatch(setData(p.props));
    }, []);
    const add = () => {
        window.location.href = Helper.route(
            tableRef.current.getState() + ".add"
        );
    };
    return (
        <>
            <Table ref={tableRef}>
                <>
                    <CTable responsive={true}>
                        <CTableHead>
                            <CTableRow>
                                <CTableHeaderCell scope="col">
                                    Name and Account Number
                                </CTableHeaderCell>
                                <CTableHeaderCell scope="col">
                                    Gender
                                </CTableHeaderCell>
                                <CTableHeaderCell scope="col">
                                    Nominee
                                </CTableHeaderCell>
                                <CTableHeaderCell scope="col">
                                    Address
                                </CTableHeaderCell>
                                <CTableHeaderCell scope="col">
                                    Village
                                </CTableHeaderCell>
                                <CTableHeaderCell scope="col">
                                    Panchayat
                                </CTableHeaderCell>
                                <CTableHeaderCell scope="col">
                                    Taluko
                                </CTableHeaderCell>
                                <CTableHeaderCell scope="col">
                                    District
                                </CTableHeaderCell>
                                <CTableHeaderCell scope="col">
                                    Contact Number
                                </CTableHeaderCell>
                                <CTableHeaderCell scope="col">
                                    Alternate Number
                                </CTableHeaderCell>
                                <CTableHeaderCell scope="col">
                                    {auth.is_admin && (
                                        <CButton
                                            size={"sm"}
                                            color="primary"
                                            onClick={() => add()}
                                            className={"float-start"}
                                        >
                                            Open New Customer Account
                                        </CButton>
                                    )}
                                </CTableHeaderCell>
                            </CTableRow>
                        </CTableHead>
                        <CTableBody>
                            {list.data !== undefined &&
                                list.data[0] === undefined && (
                                    <tr>
                                        <td colSpan={11}>
                                            Great! You are free of all entities.
                                        </td>
                                    </tr>
                                )}
                            {list.data &&
                                list.data.map((l) => {
                                    return (
                                        <CTableRow
                                            color={
                                                l?.data?.closed_at
                                                    ? "danger"
                                                    : ""
                                            }
                                            key={l.data.id}
                                        >
                                            <CTableHeaderCell scope="row">
                                                {l.data.name} #
                                                {l.data.customer_account_number}
                                                @
                                                <br />
                                                <DateDisplay
                                                    options={{
                                                        year: "numeric",
                                                        month: "numeric",
                                                        day: "numeric",
                                                    }}
                                                >
                                                    {l.data.created_at}
                                                </DateDisplay>
                                                <PrintAccountStatmentLink
                                                    customer_account_number={
                                                        l.data
                                                            .customer_account_number
                                                    }
                                                />
                                            </CTableHeaderCell>
                                            <CTableDataCell
                                                className={"text-capitalize"}
                                            >
                                                {l.data.gender}
                                            </CTableDataCell>
                                            <CTableDataCell
                                                className={"text-capitalize"}
                                            >
                                                {l.data.nominee}
                                            </CTableDataCell>
                                            <CTableDataCell
                                                className={"text-capitalize"}
                                            >
                                                {l.data.address}
                                            </CTableDataCell>
                                            <CTableDataCell
                                                className={"text-capitalize"}
                                            >
                                                {l.data.village}
                                            </CTableDataCell>
                                            <CTableDataCell
                                                className={"text-capitalize"}
                                            >
                                                {l.data.panchayat}
                                            </CTableDataCell>
                                            <CTableDataCell
                                                className={"text-capitalize"}
                                            >
                                                {l.data.taluko}
                                            </CTableDataCell>
                                            <CTableDataCell
                                                className={"text-capitalize"}
                                            >
                                                {l.data.district}
                                            </CTableDataCell>
                                            <CTableDataCell>
                                                {l.data.contact_number}
                                            </CTableDataCell>
                                            <CTableDataCell>
                                                {l.data.alternate_number}
                                            </CTableDataCell>
                                            <CTableDataCell>
                                                <CurrentBalance data={l.data} />
                                                <CButtonGroup
                                                    className={"p-1"}
                                                    size={"sm"}
                                                    role="group"
                                                    aria-label="Basic mixed styles example"
                                                >
                                                    {!(
                                                        l?.data?.closed_at ||
                                                        l?.data?.frozen_at
                                                    ) && (
                                                        <CButton
                                                            color="success"
                                                            onClick={() => {
                                                                window.location.href =
                                                                    Helper.route(
                                                                        tableRef.current.getState() +
                                                                            ".show",
                                                                        {
                                                                            customer_account:
                                                                                l
                                                                                    .data
                                                                                    .id,
                                                                        }
                                                                    );
                                                            }}
                                                        >
                                                            {auth.is_admin && (
                                                                <>Edit</>
                                                            )}
                                                            {!auth.is_admin && (
                                                                <>Open</>
                                                            )}
                                                        </CButton>
                                                    )}
                                                    {auth.is_admin &&
                                                        !(
                                                            l?.data
                                                                ?.closed_at ||
                                                            l?.data?.frozen_at
                                                        ) && (
                                                            <CButton
                                                                color="danger"
                                                                onClick={() => {
                                                                    window.location.href =
                                                                        Helper.route(
                                                                            tableRef.current.getState() +
                                                                                ".delete",
                                                                            {
                                                                                customer_account:
                                                                                    l
                                                                                        .data
                                                                                        .id,
                                                                            }
                                                                        );
                                                                }}
                                                            >
                                                                Delete
                                                            </CButton>
                                                        )}
                                                    {(l?.data?.closed_at ||
                                                        l?.data?.frozen_at) && (
                                                        <CButton
                                                            color="dark"
                                                            onClick={() => {
                                                                window.location.href =
                                                                    Helper.route(
                                                                        tableRef.current.getState() +
                                                                            ".show",
                                                                        {
                                                                            customer_account:
                                                                                l
                                                                                    .data
                                                                                    .id,
                                                                        }
                                                                    );
                                                            }}
                                                        >
                                                            <AccountFrozen
                                                                l={l}
                                                            />
                                                            <AccountClosed
                                                                l={l}
                                                            />
                                                        </CButton>
                                                    )}
                                                </CButtonGroup>
                                            </CTableDataCell>
                                        </CTableRow>
                                    );
                                })}
                        </CTableBody>
                    </CTable>
                </>
            </Table>
            <CContainer fluid={true} className={"pt-3"}>
                <Common
                    action={"search"}
                    onSearch={(res) => {
                        tableRef.current.callFromSubmitted(res);
                    }}
                />
            </CContainer>
        </>
    );
};

const AccountClosed = ({ l }) => {
    let formattedDate = "";

    if (l?.data?.closed_at) {
        // Parse the date string
        const date = new Date(l.data.closed_at);

        // Extract day, month, and year components
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear().toString().slice(-2);

        // Format the date as "dd/mm/yy"
        formattedDate = `${day}/${month}/${year}`;
    }
    if (!formattedDate) {
        return null;
    }
    return <div>Closed @ {formattedDate}</div>;
};

const AccountFrozen = ({ l }) => {
    let formattedDate = "";

    if (l?.data?.frozen_at) {
        // Parse the date string
        const date = new Date(l.data.frozen_at);

        // Extract day, month, and year components
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear().toString().slice(-2);

        // Format the date as "dd/mm/yy"
        formattedDate = `${day}/${month}/${year}`;
    }
    if (!formattedDate) {
        return null;
    }
    return <div>Frozen @ {formattedDate}</div>;
};

export default List;
